import { useState } from 'react';

export function useEstimateSectionState() {
  const [sections, setSections] = useState({
    details: false,
    advanced: false,

    customer: true,
    lineItems: true,
    financials: false,
    salesAttribution: false,
    schedule: false,
    forCustomer: false,
    terms: false,
    forInternal: false,
    customFields: false,
    // NOT-223: Scope of work, Notes to customer, and Payment schedule are now
    // "Add if needed" tiles instead of always-visible sections.
    scope: false,
    notes: false,
    paymentSchedule: false,
  });

  const toggleSection = (key: keyof typeof sections) =>
    setSections((prev) => ({ ...prev, [key]: !prev[key] }));

  return {
    sections,
    toggleSection,
  };
}
